import { render } from "./OtpAuthCOmponent.vue?vue&type=template&id=8ff291ce&ts=true"
import script from "./OtpAuthCOmponent.vue?vue&type=script&lang=ts"
export * from "./OtpAuthCOmponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__